export const sessionStorageHelper = {
	getKey(key: string) {
		try {
			const value = window.sessionStorage.getItem(key);
			return value ? JSON.parse(value) : null;
		} catch (error) {
			console.warn(`Error reading sessionStorage key "${key}":`, error);
			return null;
		}
	},
	setKey(key: string, value: string) {
		try {
			const newValue = JSON.stringify(value);
			const existingValue = window.sessionStorage.getItem(key);
			if (existingValue !== newValue) {
				window.sessionStorage.setItem(key, newValue);
			}
		} catch (error) {
			console.warn('Error setting sessionStorage key:', error);
		}
	},
	removeKey(key: string) {
		try {
			window.sessionStorage.removeItem(key);
		} catch (error) {
			console.warn(`Error removing sessionStorage key "${key}":`, error);
		}
	},
};
